import type {AlgorithmOperation} from '@algoquest/schemas';
export type SoundCue='scan'|'move'|'confirm'|'error'|'success';
export function actionSound(complete:boolean,operations:AlgorithmOperation[]):SoundCue {
 if(complete)return 'success';
 if(operations.some(o=>['SWAP','SHIFT','PLACE','INSERT'].includes(o.type)))return 'move';
 if(operations.some(o=>o.type==='SCAN'||o.type==='COMPARE'))return 'scan';
 return 'confirm';
}
type Settings={enabled:boolean;volume:number};
const key='algoquest-audio-v1';
let settings:Settings={enabled:true,volume:.35};
try {const value=JSON.parse(localStorage.getItem(key)??'null');if(value&&typeof value.enabled==='boolean'&&Number.isFinite(value.volume))settings={enabled:value.enabled,volume:Math.max(0,Math.min(1,value.volume))};}catch{}
const listeners=new Set<()=>void>();
let context:AudioContext|null=null,master:GainNode|null=null,lastCueAt=-Infinity;
export const audioSettings={
 get:()=>settings,
 subscribe(fn:()=>void){listeners.add(fn);return ()=>{listeners.delete(fn);};},
 set(next:Partial<Settings>){settings={...settings,...next};settings.volume=Math.max(0,Math.min(1,settings.volume));try{localStorage.setItem(key,JSON.stringify(settings));}catch{}if(master&&context)master.gain.setTargetAtTime(settings.enabled?settings.volume:0,context.currentTime,.02);listeners.forEach(fn=>fn());},
};
/** Called only by a real interaction; unsupported/blocked audio never blocks play. */
export function unlockAudio():void {
 try {
  if(!settings.enabled)return;
  if(!context){context=new AudioContext();master=context.createGain();master.gain.value=settings.volume;master.connect(context.destination);}
  if(context.state==='suspended')void context.resume().catch(()=>{});
 }catch{}
}
export function playSound(cue:SoundCue):void {
 if(!settings.enabled||settings.volume===0||!context||!master||context.state!=='running')return;
 const now=context.currentTime;if(cue!=='success'&&now-lastCueAt<.06)return;lastCueAt=now;
 const notes:Record<SoundCue,number[]>={scan:[720,1080],move:[260,390],confirm:[620],error:[190,150],success:[523.25,659.25,783.99,1046.5]};
 notes[cue].forEach((frequency,i)=>{
  const start=now+i*(cue==='success'?.13:.065),length=cue==='success'?.23:.11;
  const oscillator=context!.createOscillator(),gain=context!.createGain();
  oscillator.type=cue==='error'?'triangle':'sine';oscillator.frequency.setValueAtTime(frequency,start);
  gain.gain.setValueAtTime(0,start);gain.gain.linearRampToValueAtTime(.16,start+.012);gain.gain.exponentialRampToValueAtTime(.001,start+length);
  oscillator.connect(gain);gain.connect(master!);oscillator.start(start);oscillator.stop(start+length+.02);
  oscillator.onended=()=>{oscillator.disconnect();gain.disconnect();};
 });
}
